









import { Component, Prop, Vue } from 'vue-property-decorator'
import { GamePlayer } from '@/class/gamePlayer'
import { Game } from '@/class/game'
import SimpleModal from '@/components/Utils/modal/SimpleModal.vue'
import GameStateLog from './Log/GameStateLog/GameStateLog.vue'

@Component({
  components: {
    SimpleModal,
    GameStateLog,
  }
})
export default class GameStateModal extends Vue {
  @Prop() game!: Game;
  @Prop() playerSelf?: GamePlayer;

  show = true;

  created () {
    setTimeout(() => this.show = false, 5000)

    this.$watch('state', (now, prev) => {
      this.show = now !== prev

      if(this.show) {
        setTimeout(() => this.show = false, 5000)
      }
    })

    this.$watch('finalVoteTalkerId', (now, prev) => {
      if (this.game.isFinalVoteReady) {
        this.show = now !== prev
      }
    })
  }

  get state () {
    return this.game.gameState
  }

  get finalVoteTalkerId () {
    return this.game.finalVoteTalkerId
  }
}
